import { AfterViewInit, Directive, ElementRef, Inject, Input, OnDestroy } from '@angular/core';
import { IExtendedWindow } from '../../../type_definitions/datatypes';
import { DOCUMENT } from '@angular/common';
import { cssUtil } from '../util';

@Directive({
  selector: '[fillHeight]'
})
export class FillHeightDirective implements AfterViewInit, OnDestroy {
  @Input() public fillHeight: string;
  @Input() public fillHeightMethod: string;
  @Input() public insideWrapper: boolean;
  @Input() public elementId: string;

  private mutationObserver: MutationObserver;
  private jElement: JQuery<HTMLElement>;
  private resizeDebounceTimer: ReturnType<typeof setTimeout>;

  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    @Inject(Window) private window: IExtendedWindow
  ) {
    /**/
  }

  public ngAfterViewInit(): void {
    if (this.insideWrapper) {
      this.jElement = this.elementId ? $(`#${this.elementId}`) : $(this.element.nativeElement).children();
    } else {
      this.jElement = $(this.element.nativeElement);
    }

    if (this.fillHeight) {
      if (!!this.window.MutationObserver && !this.fillHeightMethod) {
        // define mutation observer
        this.mutationObserver = new MutationObserver(() => {
          // use case: in catalog when there is only 1 external catalog mutation observer will also detect mutation inside iframe
          // add timeout here to prevent hanging when there is iframe within document
          setTimeout(() => this.jElement.height(this.getFilledHeight(<string>this.fillHeight)));
        });

        // observe document with mutationObserver to listen subtree changed or modification
        // mutation observer also triggered when window resize
        this.mutationObserver.observe(this.document, {
          attributes: false,
          childList: true,
          subtree: true
        });
      } else {
        setTimeout(() => this.jElement.height(this.getFilledHeight(<string>this.fillHeight)));
        // add resize event listener for browser not supporting mutation observer
        this.window.addEventListener('resize', this.onResize, true);
      }
    }
  }

  public ngOnDestroy(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    } else {
      this.window.removeEventListener('resize', this.onResize, true);
    }
  }

  private onResize = (): void => {
    // use case: resizing window with quick mouse movement
    // add timeout here to prevent code start calculating immediately (meaning it will use height calculation the moment resizing started)
    // we just want to do calculation when the resizing event is done
    // https://css-tricks.com/snippets/jquery/done-resizing-event/
    clearTimeout(this.resizeDebounceTimer);
    this.resizeDebounceTimer = setTimeout(() => this.jElement.height(this.getFilledHeight(<string>this.fillHeight)), 250);
  };

  private getFilledHeight(definedClasses:string): number {
    // if its inside iframe then try getting innerHeight, or fallback to default 550px
    const windowHeight = this.window.frameElement? (this.window.innerHeight || 550) : this.window.innerHeight;
    const heightElements = definedClasses.split(/\s*;\s*/);

    if (!heightElements.length) {
      return windowHeight;
    }

    return windowHeight - cssUtil.sumHeights(definedClasses);
  }
}